import type { ReactNode } from 'react';

type DevelopmentProvidersProps = {
  readonly children: ReactNode;
};

export function DevelopmentProviders({ children }: DevelopmentProvidersProps) {
  // 開発時にだけ有効化したい Provider があればここに追加する。
  // 例: import.meta.env.DEV && <DevModeIndicator>
  return <>{children}</>;
}
